import { render } from "./GamificationDialog.vue?vue&type=template&id=32110a4e"
import script from "./GamificationDialog.vue?vue&type=script&lang=js"
export * from "./GamificationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__